var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.776 12.258C4.727 10.016 3.042 5.25 4.69 4.122c1.65-1.128 3.436-1.193 4.123-1.085h16.163c1.049.145 2.929 1.215 2.06 4.34-.867 3.123-1.373 4.555-1.518 4.88-.289-.686-1.02-2.408-1.627-3.796-.606-1.388-1.264-3.47-1.517-4.338h-.76l-2.17 4.339-3.254-4.338h-.977L12.284 8.46 9.898 4.123H8.813C8.56 5.134 7.945 7.42 7.511 8.46c-.433 1.042-1.336 2.966-1.734 3.798zm0 7.484c-1.049 2.242-2.734 7.008-1.085 8.136 1.65 1.128 3.436 1.193 4.123 1.085h16.163c1.049-.145 2.929-1.215 2.06-4.34-.867-3.123-1.373-4.555-1.518-4.88-.289.686-1.02 2.408-1.627 3.796-.606 1.387-1.264 3.47-1.517 4.338h-.76l-2.17-4.339-3.254 4.338h-.977l-2.929-4.339-2.386 4.338H8.813c-.253-1.012-.868-3.298-1.302-4.339-.433-1.042-1.336-2.966-1.734-3.798z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSps);
export default __webpack_public_path__ + "static/media/SPS.303959ce21fbb0b308af59c2282a8c52.svg";
export { ForwardRef as ReactComponent };